/**
 * Integration Enums
 *
 * Enums used across integration owner entities
 */

/**
 * Integration Type Enum
 * Types of integrations that can have multiple owners
 */
export enum IntegrationType {
  SALESFORCE = "SALESFORCE",
  HUBSPOT = "HUBSPOT",
  SLACK = "SLACK",
}
